import React, { useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Box, Toolbar, Typography, Link, Button } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Disclaimertext = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const receivedNumber = location.state?.number;
  const navigate = useNavigate();

  
  const [checked, setChecked] = useState(false);

  return (
    <Box>
      <Toolbar>
        <div className='diclaimer-Screen'>

          <div className='disclainerWrapper'>
            <Typography variant='h2'>{t('terms_title')}</Typography>

            <div className='tems-condition-content'>
              <Typography variant='body1' sx={{ py: '10px' }}>
                {t('terms_text')}
              </Typography>
                     <Typography variant='body1' sx={{ py: '10px' }}>
                {t('terms_text1')}
              </Typography>
                     <Typography variant='body1' sx={{ py: '10px' }}>
                {t('terms_text2')}
              </Typography>
                     <Typography variant='body1' sx={{ py: '10px' }}>
                {t('terms_text3')}
              </Typography>
                       <Typography variant='body1' sx={{ py: '10px' }}>
                {t('terms_text4')}
              </Typography>
                                 <Typography variant='body1' sx={{ py: '10px' }}>
                {t('terms_text5')}
              </Typography>
              
            </div>

            <FormGroup className='custum-checkbox'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                }
                 label={
    <Typography >
     {t('agree_terms')}
    </Typography>
  }
              />
            </FormGroup>

            <div className='custom-btn'>
              {/* Back Button */}
              <Link
                component={RouterLink}
                to="/"
                className='back-btn'
                sx={{ marginTop: '30px', marginRight: '15px' }}
              >
                {t('back_btn')}
              </Link>

              <Button
                variant="contained"
                disabled={!checked}
                sx={{ marginTop: '30px' }}
                onClick={() =>
                  navigate("/Paitentsform", {
                    state: { number: receivedNumber }
                  })
                }
              >
                {t('start_chat')}
              </Button>
            </div>
          </div>
        </div>
      </Toolbar>
    </Box>
  );
};

export default Disclaimertext;